import { render } from "./privacyComponent.vue?vue&type=template&id=3eb3293d"
import script from "./privacyComponent.vue?vue&type=script&lang=js"
export * from "./privacyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__